import { axios } from "~/plugins/request"

export const state = () => {
    return {}
}
export const mutations = {}
export const actions = {
    findByList({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`/workPlanYear/findByList`, params).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },

    findById({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`/workPlanYear/findById`, params).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },

    save({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`/workPlanYear/save`, params).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },



    getTitle({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.get(`/workPlanYear/getTitle`)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    delete({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`/workPlanYear/delete`, params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    approval({ commit }, params) {
        return new Promise((resolve, reject) => {
          axios.post('/workPlanYear/approveStart', params)
            .then(response => {
              resolve(response)
            })
            .catch(error => {
              reject(error)
            })
        })
      },

      callBack({ commit }, params) {
        return new Promise((resolve, reject) => {
          axios.post('/workPlanYear/processRecallStart', params)
            .then(response => {
              resolve(response)
            })
            .catch(error => {
              reject(error)
            })
        })
      },

      findReject({ commit }, params) {
        return new Promise((resolve, reject) => {
          axios.post('/workPlanReject/findByList', params)
            .then(response => {
              resolve(response)
            })
            .catch(error => {
              reject(error)
            })
        })
      },
      exportWorkPlan({ commit }, params) {
          return new Promise((resolve, reject) => {
            axios({
              method: 'post',
              url: '/exportExcel/exportWorkPlan',
              data: params,
              responseType: 'blob',
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(response => {
              resolve(response)
            }).catch((error) => {
              reject(error)
            })
          })
        },

  getTitle({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/workPlanYear/getTitle`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },








}
